import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class EmptyStatementCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.EmptyStatement;
    }
    visitNode(_sb, _node, _options) {
    }
}

//# sourceMappingURL=EmptyStatementCompiler.js.map
